import { createContext } from 'react';

export type AccountCreationCtx = {
  showAccountCreationSuccessAlert: boolean;
  showAccountCreationErrorAlert: boolean;
  accountCreationError: string;
};

const AccountCreationDialogueContext = createContext<AccountCreationCtx>({
  showAccountCreationSuccessAlert: false,
  showAccountCreationErrorAlert: false,
  accountCreationError: '',
});

export default AccountCreationDialogueContext;